import React, { useEffect, useState, useRef } from "react";
import { Button, CircularProgress, IconButton, ListItemText, makeStyles, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@material-ui/core";
import TablePaginationActions from "@material-ui/core/TablePagination/TablePaginationActions";
import {GlobalUseStyles} from "./GlobalUseStyles.js";
import clsx from 'clsx';
import { Add, CancelOutlined, GetApp, MoreHoriz, Error, ErrorOutline, CheckCircleOutline, PlayArrow } from "@material-ui/icons";
import CustomStatusIcon from "./CustomStatusIcon.js";
import { snackbar } from "../snackbarService";
import { useMsal } from "@azure/msal-react";
import { useHistory } from "react-router-dom";
import { deleteCompare, downloadFromS3Base64, executeCompare, getCompare, getCompares, CancelBomCompare, CancellingBomCompare, CancellingCompareConsole, TrackingPDMConnection, markStatusFlag } from "./RestService.js";
import InfiniteScroll from "react-infinite-scroller";
import { ConvertedTimeString } from "./Common.js";
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import RoutesContainer from "./RoutesContainer.js";
import { getMatchingBatches } from './Common.js';
import ModalPopup from './ModalPopup';

const useStyles = makeStyles((theme) => ({
    customTableCell: {
        padding: "0px 16px",
        //width: "20%"
      },
      tableContainer: {
        position: "absolute", 
        top: "90px", 
        bottom: 0, 
        left: 0, 
        right: 0, 
        width:"95%",
        margin: "28px",
        overflowY: "scroll",

        scrollbarWidth: "auto",
        scrollbarColor: "#0071B9 #E8EFF2",

        "&::-webkit-scrollbar": {
            width: "16px",
            height: "16px"
        },

        "&::-webkit-scrollbar-track": {
            backgroundColor: "#E8EFF2",
            borderRadius: "8px"
        },

        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#0071B9",
            borderRadius: "8px",
            border: "3px solid #E8EFF2"
        },

        "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#005F9E"
        },

        "&::-webkit-scrollbar-corner": {
            backgroundColor: "#E8EFF2"
        }
    }
}))

async function handleDownload(instance, compareName) {
    await downloadFromS3Base64(instance, "Compare", compareName);
}


export default function BomCompare(props) {
    const classes = useStyles();
    const globalClasses = GlobalUseStyles();
    const [showFooter, setShowFooter] = React.useState(false);
    const [compareData, setCompareData] = useState([]);
    const [showCompareData, setShowCompareData] = useState([]);
    const [compareLoading, setCompareLoading] = useState(false);
    const [comparesLoaded, setComparesLoaded] = React.useState(0);
    const [endReached, setEndReached] = React.useState(false);
    const [valLen, setValLen] = useState(0);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [anchorElBomCompare, setAnchorElBomCompare] = React.useState(null);
    const [selectedBomCompare, setSelectedBomCompare] = useState(null);
    const [comparesUpdatedTime, setComparesUpdatedTime] = useState(null);
    const [reRender, setReRender] = useState(false);
    const [showEmpty, setShowEmpty] = useState(false);
    const { instance, accounts, inProgress } = useMsal();
    const [lock, setLock] = useState(false);
    const history = useHistory();
    const [batches, setBatches] = useState(null);

    //DA-1696, Modal PDM popup added
    const [modalOpen, setModalOpen] = useState(false);
    const [pdmUsername, setPdmUsername] = useState('');
    const [modalResult, setModalResult] = useState(null);
    const [modalResolve, setModalResolve] = useState(null);
    const modalResolveRef = useRef(null);

    const openLoginModal = () => {
        return new Promise((resolve) => {
            setModalOpen(true);
            modalResolveRef.current = (result) => {
            setModalOpen(false);
            setModalResult(result);
            resolve(result);
            };
        });
    };

    const checkPDMLogin = async () => {
        let result = null;  
        let pdmLoginFailed = sessionStorage.getItem("pdmLoginFailed");
        if (pdmLoginFailed == "false")
        {
            return true;
        }

        result = await openLoginModal();

        console.log("RESULT: ", result);
        if (result && result.canceled && result.canceled == true)
        {
            snackbar.warning("PDM Login cancelled",300000);
            return false;
        }
        if (result && result.success && result.success == false)
        {
            let errorMsg = "Error during PDM login.";
            if (result.error && result.error != "")
            {
                errorMsg = result.error;
            }
            snackbar.warning(errorMsg,300000);
            return false;
        }
        if (result && result.success == true) {
            return true;
        }
        return false;
    };

    const loading = async () => {
        if (compareLoading == false)
        {
            setCompareLoading(true);

            setComparesLoaded(comparesLoaded+25);
            setReRender(!reRender);
            setCompareLoading(false);

            if (comparesLoaded > compareData.length)
            {
                setEndReached(true);
            }
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setReRender(!reRender);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setReRender(!reRender);
    };

    const handleBomCompareClose = (event) => {
        setSelectedBomCompare(null);
        setAnchorElBomCompare(null);
    };

    const handleNewCompare = (event) => {
        props.setSelectedBomCompare(null);
        history.push("/bomcompare/edit");
    };

    const handleCompareDeleteClick = (event) => {
        if (confirm("Are you sure you want to delete BOM compare " + selectedBomCompare["name"] + "?"))
        {
            var delResult = null;
            var message = "";
            setAnchorElBomCompare(null);
            const data = async () => {
                delResult = await deleteCompare(instance, selectedBomCompare["compareID"], accounts[0].username);
            }
            data().catch((error)=>{
                console.error(error);
                message = "Error: " + error.message;
            }).then(() => {
                if (message != "")
                {
                    snackbar.error(message,300000);
                } 
                else 
                {
                    let tmpCompareData = [...compareData];
                    var newCompareData = tmpCompareData.filter((obj) => {
                        return obj["compareID"] !== selectedBomCompare["compareID"];
                    });
                    setCompareData(newCompareData);
                    if (newCompareData.length == 0)
                    {
                        setShowEmpty(true);
                    }
                    setReRender(!reRender);
                    snackbar.success("Compare deleted successfully.",300000);
                }
            });
        }
    };

    let emptyRows = 0;

    const HandleExecuteBC = async (_selectedCompare) => {
        const loginSuccess = await checkPDMLogin();
        if (loginSuccess == false)
        {
            return;
        }
        const trackingPDMConnectionCall = async () => {
            const result = await TrackingPDMConnection(instance);
            sessionStorage.setItem("trackPDMConnectionStatus", result);
            markStatusFlag();  
            if(result != "Success")     
            {
            snackbar.error("PDM is currently down.",300000);
            return false;
            }
        }
        
        if (confirm("Are you sure you want to run comparison " + _selectedCompare["name"] + "?"))
        {
            console.log("yes: ", _selectedCompare);

            let message = "";
            let executeData = null;
            const executeCompareCall = async () => {
                executeData = await executeCompare(instance, _selectedCompare["compareID"], _selectedCompare["configurations"], _selectedCompare["compareTo"], _selectedCompare["options"], accounts[0].username);
                if (executeData["exception"])
                {
                    message += executeData["exception"];
                }
            };

            executeCompareCall().catch((error) => { message += error.message + "\n" }).then(() => {
                console.log("EXECUTED: ", executeData);
                if (message != "") {
                snackbar.error("Error: " + message,300000);
                return;
                }
                else {
                snackbar.success("BOM Compare execute started successfully.",300000);
                

                let tmpBCData = [...compareData];
                let tmpShowBCData = [...showCompareData];
                tmpBCData.forEach(element => {
                    if (element["compareID"] == executeData["compareID"])
                    {
                        element["status"] = "Processing";
                        element["lastRun"] = executeData["lastRun"];
                    }
                });
                tmpShowBCData.forEach(element => {
                    if (element["compareID"] == executeData["compareID"])
                    {
                        element["status"] = "Processing";
                        element["lastRun"] = executeData["lastRun"];
                    }
                });
                tmpBCData.sort((a, b) => new Date(a["lastRun"]).valueOf() - new Date(b["lastRun"]).valueOf()).reverse();
                tmpShowBCData.sort((a, b) => new Date(a["lastRun"]).valueOf() - new Date(b["lastRun"]).valueOf()).reverse();
                setCompareData([...tmpBCData]);
                setShowCompareData([...tmpShowBCData]);
                history.push("/bomcompare");
                }
            });
        }
    };

    const CancelButton = async (clickedCompare) => {
        console.log("clickedCompare: ", clickedCompare);
        let answer = window.confirm("Are you sure you want to cancel the run?");
        if (answer == true)
        {
            const cancelCompareResult = await CancelBomCompare(instance, clickedCompare["compareID"], clickedCompare["configurations"], clickedCompare["compareTo"], clickedCompare["options"], accounts[0].username, clickedCompare["name"],clickedCompare["lastRun"]);
            if (cancelCompareResult["exception"])
            {
                snackbar.warning(cancelCompareResult["exception"],300000);
            }            
            else
            {
              snackbar.success("Bom Compare execute stopped.",300000);
              clickedCompare["status"] = "Cancelled";
              handleCancelClick(clickedCompare);
              setReRender(!props.reRender);
            }  
        }
    };

    const CancellingButton = async (clickedCompare) => {
        setLock(true);
        console.log("clickedCompare: ", clickedCompare);
        let answer = window.confirm("Are you sure you want to cancel the run?");
        if (answer == true)
        {
            const cancelCompareResult = await CancellingBomCompare(instance, clickedCompare["compareID"], clickedCompare["configurations"], clickedCompare["compareTo"], clickedCompare["options"]);
            console.log("cancelCompareResult::"+cancelCompareResult);
            if (cancelCompareResult["exception"])
            {
                snackbar.warning(cancelCompareResult["exception"],300000);
                setLock(false);
            }            
            else
            {
              snackbar.success("Bom Compare execute stopped.",300000);
              clickedCompare["status"] = "Cancelled";
              handleCancelClick(clickedCompare);
              setReRender(!props.reRender);
            }  
            const cancelCompareConsoleResult = await CancellingCompareConsole(instance, accounts[0].username, clickedCompare["name"],clickedCompare["lastRun"]);
            setLock(false);
            if (cancelCompareConsoleResult == "Failed") {
                snackbar.warning("Console side failed to cancel BOM Compare.",300000);
            }
        }
    };

    const handleCancelClick = (clickedCompare) => {
        let tmpCompareData = compareData;
        var batch = tmpCompareData.findIndex((obj) => {
            return obj["compareID"] == clickedCompare["compareID"];
        });
        tmpCompareData[batch]["status"] = clickedCompare["status"];
        setCompareData(tmpCompareData);
    };

    useEffect(() => {
        const data = async () => {
            let foundCompare = [];
            const allData = await getCompares(instance);

            if (allData?.exception) {
                const error = new Error(allData.exception);
                error.status = 404;
                throw error;
            }
            
            // Filtering automated PDM CAD Comparison coming from Batches.
            const filteredData = allData.filter(item => item.compareType !== "PDM CAD Comparison");

            // console.log("Filtered Matching Batches:", filteredData);
            
            if(filteredData && filteredData.length > 0) {
              filteredData.sort((a, b) => new Date(a["lastRun"]).valueOf() - new Date(b["lastRun"]).valueOf()).reverse();
              emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
              setValLen(filteredData.length);
              let tmpValData = [...filteredData];
              tmpValData = tmpValData.slice(0, 25);
              setCompareData([...filteredData]);
              setShowCompareData([...tmpValData]);
            }
            else
            {
                setShowEmpty(true);
                setReRender(!reRender);
                snackbar.warning("No Records found.",300000);
                return false;
            }
            /*const newData = await getCompares(instance, accounts[0].username, "Master Structure");
            const newData2 = await getCompares(instance, accounts[0].username, "Configuration Structure");
            const newData3 = await getCompares(instance, accounts[0].username, "PDM CAD Comparison");
            let filteredData = [];
            filteredData = filteredData.concat(newData);
            filteredData = filteredData.concat(newData2);
            filteredData = filteredData.concat(newData3);*/
            
        };
        data().catch((error) => {
            setShowEmpty(true);
            setReRender(!reRender);
            if ("status" in error && error["status"] == 404)
            {
                snackbar.warning(error.message,300000);
            }
            else
            {
                snackbar.error(error.message,300000);
            }
        });
    },[]);

    useEffect(() => {
        compareData.sort((a, b) => new Date(a["lastRun"]).valueOf() - new Date(b["lastRun"]).valueOf()).reverse();
        emptyRows = rowsPerPage - Math.min(rowsPerPage, compareData.length - page * rowsPerPage);
        setValLen(compareData.length);
        let tmpValData = [...compareData];
        tmpValData = tmpValData.slice(0, comparesLoaded);
        setShowCompareData([...tmpValData]);
    },[reRender]);

    const updateIntervalCompares = async () => {
        let processingCompares = compareData.filter((b) => b["status"] == "Processing")
        let tmpCompareData = [...compareData];
                      
        const compareUpdates = processingCompares.map((b) => {
            return getCompare(instance, b["compareID"]);
        });
        await Promise.all(compareUpdates).then(data => {
            data.forEach(element => {
                var compare = tmpCompareData.findIndex((obj) => {
                    return obj["compareID"] == element["compareID"];
                });
               
                if (tmpCompareData[compare] != element)
                {
                    tmpCompareData[compare] = element;
                }
            });
            setShowCompareData(tmpCompareData);
            setCompareData(tmpCompareData);
            var date = new Date();
            setComparesUpdatedTime(date);
              
        }).catch((err) => {
            snackbar.error("Error: " + err,300000);
        });
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (compareData.length > 0)
            {
                updateIntervalCompares();
            }
          }, 45000);
        
          return () => {
            clearInterval(interval);
        };
    },[compareData]);

    return (
        <>
        <div className={globalClasses.textBar} style={{paddingBottom: "0"}}>
                    <Typography variant="h5" color="textPrimary" align="left">
                        {'BOM compare'}
                    </Typography>
                    {/* <p className={classes.topBarItem}>KONE Material:</p>
                <ReactDropdown options={materials} value={defaultMaterial} placeholder="-"
            onChange={onDropdownSelect} className={clsx(classes.materialDropdown, classes.topBarItem)} /> */}
                    <div className={globalClasses.createTestButtonDiv}>
                        <Button variant="contained" className={clsx(globalClasses.blueButton)} onClick={handleNewCompare}>
                            <Add /> New BOM Comparison
                        </Button>
                    </div>
                </div>
                
                <div>
                {comparesUpdatedTime != null
                            ?
                            <Typography variant="body1" color="textSecondary" align="right" style={{fontSize: "0.75rem", marginLeft: "auto", marginRight: "7px", marginTop: "auto"}}>
                                {"Last refreshed: " + new Date(comparesUpdatedTime).toLocaleString()}
                            </Typography>
                            :
                            <></>
                            }
                </div>

                {showEmpty == true 
        ?
        <></>
        :
        <>
                <TableContainer component={Paper} className={clsx(classes.tableContainer)}>
            <InfiniteScroll
            pageStart={0}
            loadMore={compareData.length == 0 ? ()=>{} : loading}
            hasMore={(endReached && !compareLoading) ? false : (true || false)}
            loader={ <CircularProgress key={0} />}
            useWindow={false}
            >
            <Table className={globalClasses.mainTable}>
                <TableHead>
                    <TableRow key={-2} className={globalClasses.titleRow}>
                            <TableCell key={"BCExecute"} className={globalClasses.titleCell} style={{width: "4%"}}>
                                {""}
                            </TableCell>
                        <TableCell key={"DataValidation"} className={globalClasses.titleCell}>
                            {""}
                        </TableCell>
                        <TableCell key={"Status"} className={globalClasses.titleCell}>
                            {""}
                        </TableCell>
                        <TableCell key={"Type"} className={globalClasses.titleCell}>
                            {""}
                        </TableCell>
                        <TableCell key={"Edit"} className={globalClasses.titleCell}>
                            {""}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {showCompareData.map((element, index) => {
                        return(
                        <TableRow key={element["name"] + "_" + index.toString()} className={globalClasses.titleRow}>
                        {/* <TableCell>
                            <Checkbox 
                                indeterminate={numSelected > 0 && numSelected < rowCount}
                                checked={rowCount > 0 && numSelected === rowCount}
                                onChange={onSelectAllClick}
                                />
                            </TableCell> */}
                        <TableCell className={classes.customTableCell}>
                                {element["status"] != "Processing"
                                ?
                                <Tooltip title={"Run BOM Comparison"}>
                                    <IconButton className={clsx(globalClasses.customButton, globalClasses.blueColor)} onClick={(e)=>{
                                        HandleExecuteBC(element);
                                    }}>
                                    <PlayArrow />
                                    </IconButton>
                                </Tooltip>
                                :
                                <></>
                                }
                            </TableCell>

                            <TableCell className={classes.customTableCell}>
                        <ListItemText
                            style={{ margin: "0"}}
                            
                            disableTypography
                            primary={<Typography className={clsx({ //currentSelection.indexOf(index3) > -1,
                                [globalClasses.smallFont]: true
                            })}>{element["name"] + ", " + element["description"]}</Typography>}
                            secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)"}}>{ConvertedTimeString(element["created"])}</Typography>}
                />
                        </TableCell>
                        <TableCell className={classes.customTableCell} align="center">
                                <div>
                            <Tooltip title={element["status"]}>
                                <span>
                                <CustomStatusIcon status={element["status"]}></CustomStatusIcon>
                                </span>
                            </Tooltip>
                                </div>
                        </TableCell>
                        <TableCell className={classes.customTableCell} align="center">
                            {/* <Typography className={globalClasses.smallFont}>{element["type"]}</Typography> */}
                            <ListItemText
                            style={{ margin: "0"}}
                            
                            disableTypography
                            primary={<Typography className={clsx({ //currentSelection.indexOf(index3) > -1,
                                [globalClasses.smallFont]: true
                            })}>{element["compareType"]}</Typography>}
                            secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)"}}>{element["status"] == "Not run" ? " " : ConvertedTimeString(element["lastRun"])}</Typography>}
                />
                        </TableCell>
                        <TableCell className={classes.customTableCell} align="right">
                        {
                            //element["status"] == "Processing" 
                            ((element["status"] == "Processing" || element["status"] == "InProgress") && element["status"] != "Cancelled") 
                            ?
                            <IconButton title={"Cancel"} style={{marginRight: "8px"}} className={globalClasses.customButton} onClick={(e)=>{
                                // Cancel button functionality
                                //CancelButton(element);
                                CancellingButton(element);
                                e.stopPropagation();
                            }}>
                                <CancelOutlined />
                            </IconButton>
                            : 
                            <IconButton style={{width: "32px"}} className={globalClasses.customButton}>

                            </IconButton>
                        }
                        {element["status"] == "Success"
                        ?
                        <IconButton className={globalClasses.customButton} onClick={(e)=>{
                            //props.handleSetAnchorElBatch(e);
                            e.stopPropagation();
                            setSelectedBomCompare(element);                                                        
                            if (element["name"] != null)
                              handleDownload(instance, element["name"]);
                            }}>
                            <GetApp />
                        </IconButton>
                        :
                        null
                        }
                        <IconButton className={globalClasses.customButton} onClick={(e)=>{
                            setSelectedBomCompare(element);
                            setAnchorElBomCompare(e.target);
                            e.stopPropagation();
                            }}>
                            <MoreHoriz />
                        </IconButton>
                        </TableCell>
                    </TableRow>
                    );
                    })}
                    {/* {batchesExcel} */}
                </TableBody>
                {
                    showFooter ?
                    <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                    colSpan={3}
                                    count={valLen}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: { 'aria-label': 'rows per page' },
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                    
                                    />
                            </TableRow>
                        </TableFooter>
                        :
                        null
                    }
            </Table>
            </InfiniteScroll>
        </TableContainer>

        {/* DA-1969: PDM login popup */}
        <ModalPopup
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            title="PDM Sign in"
            instance={instance}
            accounts={accounts}
            setPdmUsername={setPdmUsername}
            onResolve={modalResolveRef.current}
        />
        
            <Menu
                id="simple-menu"
                anchorEl={anchorElBomCompare}
                getContentAnchorEl={null}
                keepMounted={false}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={Boolean(anchorElBomCompare)}
                onClose={handleBomCompareClose}
            // PaperProps={{
            //     style: {
            //       transform: 'translateX(0) translateY(64px)',
            //     },
            //   }}
            >
                <MenuItem 
                disabled={selectedBomCompare == null ? false : selectedBomCompare["status"] == "Processing" ? true : false}
                onClick={() => {
                    props.setSelectedBomCompare(selectedBomCompare);
                    history.push("/bomcompare/edit")
                }}>Edit</MenuItem>
                <MenuItem disabled={selectedBomCompare == null ? false : selectedBomCompare["status"] == "Processing" ? true : false} onClick={handleCompareDeleteClick}>Delete</MenuItem>
            </Menu>
        </>}
        </>
    );
}